import { gql } from '@apollo/client';

export const GET_RECENT_MOVEMENTS = gql`
  query GetRecentMovements($limit: Int!) {
    recentMovements(limit: $limit) {
      id
      itemId
      itemName
      quantity
      type
      location
      timestamp
    }
  }
`;

// ... existing queries 